export default {
  currentPage: {sideNav:{}, pageContent:{}},
  apiCallsInProgress: 0
};
